import { render, staticRenderFns } from "./LockRequestsTable.vue?vue&type=template&id=4cdf89b0&"
import script from "./LockRequestsTable.vue?vue&type=script&lang=js&"
export * from "./LockRequestsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports